import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ScannerEffects } from './scanner.effects';
import { IScannerFeature } from './scanner.feature.state';
import { scannerReducer } from './scanner.reducer';

@NgModule({
  imports: [StoreModule.forFeature(nameof<IScannerFeature>('scannerFeature'), scannerReducer), EffectsModule.forFeature([ScannerEffects])],
})
export class ScannerStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: ScannerStateModule
  ) {
    if (parentModule) {
      throw new Error('ScannerStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
